import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "quotewizard" }
const _hoisted_2 = { class: "container purchasesummary-end" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "title",
  style: {"text-align":"center","color":"#333"}
}
const _hoisted_7 = {
  key: 1,
  class: "title",
  style: {"text-align":"center","color":"#333"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center","margin-top":"4px","line-height":"22px"} }, " Thank you for your purchase. We'll email you a confirmation of your policy. ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "mobilecollpasetable"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", {
  width: "48%",
  valign: "top",
  class: "success"
}, [
  /*#__PURE__*/_createElementVNode("table", {
    width: "100%",
    border: "0",
    cellspacing: "0",
    cellpadding: "0"
  }, [
    /*#__PURE__*/_createElementVNode("tbody", null, [
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", {
          width: "20%",
          valign: "top"
        }, [
          /*#__PURE__*/_createElementVNode("span", { class: "bigsuccess-checkmark" })
        ]),
        /*#__PURE__*/_createElementVNode("td", { valign: "top" }, [
          /*#__PURE__*/_createElementVNode("strong", null, "Your Renters Insurance"),
          /*#__PURE__*/_createElementVNode("ul", null, [
            /*#__PURE__*/_createElementVNode("li", null, "Property Damage & Personal Liability"),
            /*#__PURE__*/_createElementVNode("li", null, "Personal Property Coverage")
          ]),
          /*#__PURE__*/_createElementVNode("b", null, "Success! You're Covered."),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("span", { style: {"color":"#777","font-size":"13px","line-height":"18px"} }, [
            /*#__PURE__*/_createElementVNode("b", null, "Bank Statement Notice:"),
            /*#__PURE__*/_createElementVNode("br"),
            /*#__PURE__*/_createTextVNode(" Transaction may appear as \"AGI* Renters/Condo Ins\". ")
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_13 = {
  key: 0,
  valign: "top",
  class: "success"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("table", {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", {
        width: "20%",
        valign: "top"
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "bigsuccess-checkmark" })
      ]),
      /*#__PURE__*/_createElementVNode("td", { valign: "top" }, [
        /*#__PURE__*/_createElementVNode("strong", null, "Your Personal Property Coverage Add-On"),
        /*#__PURE__*/_createElementVNode("ul", null, [
          /*#__PURE__*/_createElementVNode("li", null, "Accidental Damage Add-On")
        ]),
        /*#__PURE__*/_createElementVNode("b", null, "Success! You're Covered.")
      ])
    ])
  ])
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "notice"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://manage.myassurantpolicy.com/",
  target: "_blank"
}, " MyAssurantPolicy ", -1)
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://manage.myassurantpolicy.com/",
  target: "_blank"
}, " MyAssurantPolicy ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.nssi.com/customer/account/login/",
  target: "_blank"
}, "NSSI.com ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { EmailService } from "@/api/EmailService";
import { ReceiptService } from "@/api/ReceiptService";
//import { getReceipts } from "@/services/Functions";
import { onMounted, watch, ref, Ref } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { useUserStore } from "@/stores/root/users";
import { useGtag } from "vue-gtag-next";

const title = "Done";

export default /*#__PURE__*/_defineComponent({
  __name: 'QuoteDone',
  props: {
  anchor: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;



const applicationPdfLink: Ref<string> = ref("");
const orderLink: Ref<string> = ref("");
const quote = useQuoteStore();
const userStore = useUserStore();
const user = userStore.user;
const gtag = useGtag();

const getReceipt = async () => {
  //TODO get links and reusable function
  const response = await ReceiptService.getReceiptLink(quote);
  if (response.error === false) {
    applicationPdfLink.value = response.result.application_pdf_link;
    orderLink.value = response.result.order_link;
  }
};

watch(quote, (current) => {
  //If purchase is succesful,logs out
  if (current.done) {
    track(current);
    userStore.logout();
    sessionStorage.removeItem("log");
  }
});

onMounted(async () => {
  //Curly braces were missing after if here
  if (!quote.done) {
    await getReceipt();
    EmailService.sendOrderReceipt(
      quote,
      user,
      applicationPdfLink.value,
      orderLink.value
    );
    quote.done = true;
  }
});

const generateApplicationPdf = async () => {
  if (applicationPdfLink.value !== "") {
    window.open(applicationPdfLink.value);
  }
};

const generateOrderPdf = async () => {
  if (orderLink.value !== "") {
    window.open(orderLink.value);
  }
};
const track = (current: any) => {
  try {
    if (
      !current?.rentersInsurance?.policyNumber ||
      !current?.rentersInsurance?.dueToday
    ) {
      throw new Error(
        "Invalid data structure or missing properties in 'current'."
      );
    }

    gtag.event("purchase", {
      transaction_id: current.rentersInsurance.policyNumber,
      affiliation: "Renters",
      value: current.rentersInsurance.dueToday,
      currency: "USD",
      country: "US",
    });

    console.log("Purchase event tracked by GA4!");
  } catch (error: any) {
    console.error("Error tracking purchase event:", error.message);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      (_unref(quote).hasPersonalInsurance)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Done! Your policies are all set. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, " Done! Your policy is all set. ")),
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _createElementVNode("table", _hoisted_11, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _hoisted_12,
            (_unref(quote).hasPersonalInsurance)
              ? (_openBlock(), _createElementBlock("td", _hoisted_13, _hoisted_15))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _hoisted_16,
      _hoisted_17,
      _createElementVNode("table", {
        width: "100%",
        border: "0",
        cellspacing: "0",
        cellpadding: "0",
        class: "gold notice"
      }, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                target: "_blank",
                onClick: generateOrderPdf
              }, " View your order receipt (PDF) "),
              _createTextVNode("   |   "),
              _createElementVNode("button", {
                target: "_blank",
                onClick: generateApplicationPdf
              }, " View your application (PDF) ")
            ])
          ])
        ])
      ]),
      _createElementVNode("table", _hoisted_18, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            (!_unref(quote).hasPersonalInsurance)
              ? (_openBlock(), _createElementBlock("td", _hoisted_19, [
                  _createTextVNode(" To manage your policy, use "),
                  _hoisted_20,
                  _createTextVNode(" . ")
                ]))
              : (_openBlock(), _createElementBlock("td", _hoisted_21, [
                  _createTextVNode(" To manage your policies, visit "),
                  _hoisted_22,
                  _createTextVNode(" for renter insurance & use "),
                  _hoisted_23,
                  _createTextVNode(" for your accidental damage coverage add-on. ")
                ]))
          ])
        ])
      ]),
      _hoisted_24
    ])
  ]))
}
}

})